/** @jsx jsx */
import { jsx, Flex, Text } from 'theme-ui'
import React from 'react'
import StarRatings from 'react-star-ratings'

const CustomStarRating = props => {
  // const reviewCount = props.reviewCount && props.reviewCount.split('_')

  return (
    <>
      <StarRatings
        rating={props.rating}
        changeRating={props.changeRating}
        starRatedColor="black"
        starHoverColor="gold"
        numberOfStars={5}
        starDimension="20px"
        starSpacing="0"
        {...props}
      />
      {props.reviewCount && (
        <Text variant="caption" ml={'3px'}>
          ({props.reviewCount})
        </Text>
      )}
    </>
  )
}

export default CustomStarRating
